import { ButtonColors } from '../../enums/components/Button/ButtonColor.enum';

export interface LinkActionButton {
  text: string;
  style: ButtonColors;
  buttonType: ButtonType.Url;
  url: string;
}

export interface ModalActionButton {
  text: string;
  style: ButtonColors;
  buttonType: ButtonType.Modal;
  modalText: string;
}

export type ActionButton = LinkActionButton | ModalActionButton;

export enum ButtonType {
  Url = 'url',
  Modal = 'modal',
}

export const BUTTON_TYPES = [
  { label: 'URL', value: ButtonType.Url },
  { label: 'Modal', value: ButtonType.Modal },
];
